var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiLabelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.614,
    height: 49.633,
    viewBox: "0 0 152.614 49.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_Label_outline",
    d: "M0,1.223,9.135,15.37,0,42.338,147.585,38.7l-10.717-17.77L144.728,0Z",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 1.86, 6.223)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLabelOutline);
export default __webpack_public_path__ + "static/media/UI_Label_outline.1c0123856f98a15386576984a612fcf4.svg";
export { ForwardRef as ReactComponent };